import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChipSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChipSimple"><Path d="M14 14H10V10H14V14Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M11 3H13V1H15V3H21V9H23V11H21V13H23V15H21V21H15V23H13V21H11V23H9V21H3V15H1V13H3V11H1V9H3V3H9V1H11V3ZM8 16H16V8H8V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChipSimple;
